import { Component, Input } from '@angular/core';
import { TrackToolStep } from '@analytics/models';
import { ScPhoneFormInput } from '@innogy/sitecore-forms/models';
import { FormState } from 'ngrx-forms';
import { PhoneComponent } from '@innogy/common-ui/forms';

@Component({
  selector: 'wl-sc-phone[control][fields][trackStep]',
  templateUrl: './sc-phone.component.html',
  standalone: true,
  imports: [PhoneComponent],
})
export class ScPhoneComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() control!: FormState<string>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() fields!: ScPhoneFormInput;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabel = false;
}
